import React, {useState, useEffect} from 'react';
import {makeStyles} from '@mui/styles';
import {
  i18n
} from '../../translate/i18n';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Tooltip from '@mui/material/Tooltip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Comment from '@mui/icons-material/Comment';
import AttachFile from '@mui/icons-material/AttachFile';

import {
  Container,
  TitleContent,
  CreateButton,
  EditButton,
  DeleteButton,
} from './styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
    position: 'relative',
    width: '100%',
  },
  button: {
    fontSize: 16,
    color: '#737373',
  },
  listItem: {
    width: '100%',
  },
  listAccordion: {
    padding: '0px 0px 0px 25px',
    height: 39,
    marginTop: -25,
  },
  questionLabel: {
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: '0.8rem',
	},
	listItemQuestion: {
		display: 'flex',
		// flexDirection: 'column',
		alignItems: 'center',
    justifyContent: 'space-between',
		borderTop: '1px solid #ccc',
	},
  listItemPadding: {
    paddingTop: 4,
    paddingBottom: 4
  },
  expansionHeader: {
    marginTop: '10 !important',
    marginBottom: '10 !imporntant'
  },
  questionLabelEmpty: {
    color: '#808080',
    fontSize: '0.8rem',
	},
}));

const Checklist = ({data, detailsEnabled, editionVersion ,handleClickEditQuestion, handleEditGroup, handleDeleteGroup, handleClickAddQuestion}) => {
  const classes = useStyles();
  const [items, setItems] = useState([]);

  const handleExpand = (id) => {
    setItems(
      items.map((group) => {
        return {
          ...group,
          expanded: group._id === id ? !group.expanded : group.expanded,
        };
      })
    );
  };

  useEffect(() => {
    setItems(
      data.map((group) => {
        return {
          ...group,
          expanded: true,
        };
      })
    );
  }, [data]);


  return (
    <Container cursorType={detailsEnabled} style={{backgroundColor: items.length !== 0 ? '#ddd' : '#fff'}}>
      {items.map((group) => (
        <Accordion id={group._id} expanded={group.expanded} key={group._id}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon />
            }
            classes={{content: classes.expansionHeader}}
            onClick={() => handleExpand(group._id)}
          >
            <div className={classes.heading}>
              <TitleContent>
                {group.name}
                {editionVersion &&
                  <EditButton onClick={(e) => handleEditGroup(e, group)}>
                    <EditIcon className={classes.button} />
                  </EditButton>}
                {editionVersion &&
                  <DeleteButton onClick={(e) => handleDeleteGroup(e, group)}>
                    <DeleteIcon className={classes.button} />
                  </DeleteButton>}
              </TitleContent>
              {editionVersion && <CreateButton onClick={(e) => handleClickAddQuestion(e, group)}>{i18n.t('createButtonCompChecklist.question')}</CreateButton>}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              className={classes.root}
            >
              {group.questionArray.length === 0 &&
                (
                  <ListItem classes={{ root: classes.listItemPadding }}>
                    <ListItemText classes={{primary: classes.questionLabelEmpty}} primary={i18n.t('listChecklistItem.primary')}  />
                  </ListItem>
              )}
              {group.questionArray &&
                group.questionArray.map((el) => (
                  <List component="div" disablePadding key={el._id}>
                    <ListItem
											button
											disabled={!detailsEnabled}
											classes={{ root: classes.listItemQuestion }}
											onClick={() => detailsEnabled? handleClickEditQuestion(el, group) : null}
										>
                      <div style={{display: 'flex', width: '90%'}}>
                        {el.photo && <img src={el.photo.url} style={{ maxWidth: '4rem', maxHeight: '4rem', marginRight: 10 }} />}
                        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                          <div>{el.name}</div>
                          {el.description && <div
                            className="ck-content"
                            dangerouslySetInnerHTML={{ __html: el.description}}
                            style={{ fontSize: '0.9rem', fontWeight: 'normal', color: 'grey' }}
                          />}
                        </div>
                      </div>
                      <div>
                        {el.commentFlag && <Tooltip title={i18n.t('tooltipCommentFlagIcon.tooltip')}><Comment /></Tooltip>}
                        {el.fileFlag && <Tooltip title={i18n.t('tooltipCommentFlagIcon.tooltipFileFlag')}><AttachFile /></Tooltip>}
                      </div>
                    </ListItem>
                  </List>
                ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
};

export default Checklist;
